import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "menu" }
const _hoisted_2 = { id: "popup" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  border: "1",
  style: {"width":"100%"}
}
const _hoisted_5 = { width: "85%" }
const _hoisted_6 = { width: "15%" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("u", null, "前一页", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { style: {"width":"40%"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("u", null, "后一页", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", { href: "https://beian.miit.gov.cn/#/Integrated/index" }, "沪ICP备2025140105号", -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_listview = _resolveComponent("listview")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectauthor=!_ctx.selectauthor))
      }, [
        _createElementVNode("u", null, _toDisplayString(_ctx.curauthor), 1)
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allauthors, (author) => {
        return _withDirectives((_openBlock(), _createBlock(_component_listview, { id: "subjectselect" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              onClick: ($event: any) => (_ctx.authorclick(author))
            }, _toDisplayString(author), 9, _hoisted_3)
          ]),
          _: 2
        }, 1536)), [
          [_vShow, _ctx.selectauthor]
        ])
      }), 256))
    ], 512), [
      [_vShow, _ctx.selectauthor]
    ]),
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hidepop && _ctx.hidepop(...args))),
      id: "booklist"
    }, [
      _createElementVNode("table", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.books, (book) => {
          return (_openBlock(), _createElementBlock("tr", null, [
            _createElementVNode("td", _hoisted_5, _toDisplayString(book.bookname), 1),
            _createElementVNode("td", _hoisted_6, [
              _createElementVNode("a", {
                a: "",
                href: book.booklink
              }, _toDisplayString(book.open), 9, _hoisted_7)
            ])
          ]))
        }), 256))
      ])
    ]),
    _createElementVNode("div", {
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hidepop && _ctx.hidepop(...args))),
      id: "page"
    }, [
      _createElementVNode("div", {
        class: "hlink",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.prevpage && _ctx.prevpage(...args))),
        style: {"width":"30%"}
      }, _hoisted_9),
      _createElementVNode("div", _hoisted_10, "第" + _toDisplayString(_ctx.pageno) + "页，共" + _toDisplayString(_ctx.total) + "页", 1),
      _createElementVNode("div", {
        class: "hlink",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.nextpage && _ctx.nextpage(...args))),
        style: {"width":"30%"}
      }, _hoisted_12)
    ]),
    _createElementVNode("div", {
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hidepop && _ctx.hidepop(...args))),
      id: "icp"
    }, _hoisted_14)
  ], 64))
}